import React, { useState } from "react";
import { latestProjects } from "../../../Data/Data";
import Project from "../../utils/Project";
import Pagination from "../../utils/Pagination";

const Projects = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const totalPages = Math.ceil(latestProjects.length / itemsPerPage);

  const newData = latestProjects.slice(indexOfFirstItem, indexOfLastItem);
  return (
    <>
      <h2 className="text-lg py-[1.3rem]">Personal Projects</h2>
      <section className="bg-box p-4 space-y-5">
        <div className="flex flex-col gap-5">
          {newData.map((item) => (
            <Project item={item} key={item.id} />
          ))}
        </div>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
      </section>
    </>
  );
};

export default Projects;
